import FlexBox from 'components/flex-box';
import ListCell from 'components/list/list-cell';
import ListRow from 'components/list/list-row';
import React from 'react';
import { Folder } from 'lucide-react';
import { SubFolder } from '../types/shared-folder.type';

type Props = {
  folder: SubFolder;
  handleClick: (folderId: string) => void;
};

const FolderRow: React.FC<Props> = ({ folder, handleClick }) => {
  return (
    <ListRow key={folder.id}>
      <ListCell align="left" sx={{ width: '100%' }}>
        <FlexBox
          flexDirection={'row'}
          height={'100%'}
          alignItems={'center'}
          paddingY={2}
          sx={{
            paddingY: 2,
            cursor: 'pointer',
          }}
          onClick={() => handleClick(folder.id)}>
          <Folder size={16} />
          {folder.name}
        </FlexBox>
      </ListCell>
    </ListRow>
  );
};

export default React.memo(FolderRow);
